import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import MUIDataTable from "mui-datatables"
import { useSnackbar } from 'notistack'
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useHistory } from 'react-router-dom'
import { useAuth } from '../../hooks/auth'
import { ShedsUserCheckInMvmMonitor } from '../../interfaces/Mvm'
import MvmApi from '../../services/MvmApi'
import { DataFormat } from '../../utils/componentUtils'
import CheckInManual from './CheckInManual'
import { useStyles } from './Style'
import Box from '@mui/material/Box'
import alert from '../../pages/Concierge/Manage/images/alert.gif'
import CountUp from '../../components/Form/CountUp'

type Props = {
    reloadOnCLick?: any;
    getCounts?: any;
}

const CheckIn: React.FC<Props> = (props) => {
    const classes = useStyles();
    const { t: _t } = useTranslation("General");
    const { t: t } = useTranslation("ShedCheckin");
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [shedId, setShedId] = React.useState(0);
    const [shedsChekOut, setShedsChekOut] = React.useState<any>([]);
    const [mvmId, setMvmId] = React.useState(0);
    const [checkinManual, setCheckinManual] = React.useState(false);
    const [filterData, setFilterData] = React.useState<ShedsUserCheckInMvmMonitor[]>([]);
    const { user } = useAuth();
    const { enqueueSnackbar } = useSnackbar();
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const { isLoading, isFetching, data, refetch } = useQuery('getShedsUserCheckInMvmMonitorList', async () => {
        props.getCounts();
        return await MvmApi.getShedsUserCheckInMvmMonitorList(+user.company.plantID, user.userName);
    }, {
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: true,
        staleTime: 1000 * 360, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 1200, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    useEffect(() => {
        refetch();
    }, []);

    useEffect(() => {
        if (props.reloadOnCLick > 0) {
            refetch();
        }
    }, [props.reloadOnCLick]);

    const handleConfirmation = async () => {
        setDialogOpen(false);
        //setOpenBackdrop(true);

        MvmApi.shedCheckin(mvmId, [shedId])
            .then(() => {
                enqueueSnackbar(t("checkinSuccess"), { variant: 'success' });
            })
            .finally(async () => {
                await refetch();
                // props.getCounts(); 
                setOpenBackdrop(false);
            });
    };

    const handleDialogClickOpen = (idMvm: number, idShed: number) => {
        setMvmId(idMvm);
        setShedId(idShed);
        setDialogOpen(true);
    };

    const handleDialogClickClose = () => {
        setDialogOpen(false);
    };

    const load = async () => {
        if (data != null && data.length > 0) {
            setFilterData(data.filter((elem: { checkinDate: null }) => elem.checkinDate == null));
        } else {
            setFilterData([]);
        }
        setOpenBackdrop(false);
    }

    useEffect(() => {
        try {
            load();
        } catch (error) {
            setOpenBackdrop(false);
        }
    }, [data]);

    const columns = [
        { //0
            name: 'checkinDate',
            options: {
                display: false
            }
        },
        { //1
            name: 'flagWindowStatus',
            options: {
                display: false
            }
        },
        { //2
            name: 'shedId',
            options: {
                display: false
            }
        },
        { //3
            name: 'canCheckIn',
            options: {
                display: false
            }
        },
        { //4
            name: 'canCheckIn1',
            options: {
                display: false
            }
        },
        { //5
            name: 'mvmShedId',
            options: {
                display: false
            }
        },
        { //6
            style: { marginRight: "10px" },
            name: 'mvmId',
            label: " ",
            innerWidth: 10,
            options: {
                customBodyRender: (value: any, tableMeta: any) => {
                var canCheckIn1: any = filterData[tableMeta.rowIndex].canCheckIn1;
                const can =
                    canCheckIn1 === true ||
                    canCheckIn1 === "true" ||
                    canCheckIn1 === 1 ||
                    canCheckIn1 === "1";

                    if (can == true) {
                            return(
                                <Button
                                    variant="outlined"
                                    style={{
                                        height: "100%",
                                        width: "60%",
                                        fontSize: "0.7rem",
                                        padding: "2px",
                                        marginLeft: "40px"

                                    }}
                                    onClick={() => handleDialogClickOpen(value, tableMeta.rowData[5])}>
                                    CheckIn
                                </Button>)
                        }
                        else {
                            return <div style={{ minWidth: 140, textAlign: "center" }}><span>{t("shedCheckin") + tableMeta.rowData[3]}</span></div>;
                        }
                    }
            },
        },
        { //7
            name: 'mvmCode',
            label: t("mvmCode"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return `${filterData[tableMeta.rowIndex].mvmCode} ${filterData[tableMeta.rowIndex].mviNumber != null ? `(` + filterData[tableMeta.rowIndex].mviNumber + `)` : ""}`;
                },
            }

        },
        { //8
            name: 'vehiclePlateNumber',
            label: t("plate"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        { //9
            name: 'vehicleTypeDescription',
            label: t("vehicleTypeDescription"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        { //10
            name: 'shedCode',
            label: t("local"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        { //11
            name: 'shedType',
            label: t("modality"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return <span style={{ minWidth: 10 }}>{value == 'D' ? 'Descarga' : 'Carga'}</span>;
                }
            }
        },
        { //12
            name: 'movementTypeDescription',
            label: t("movementTypeDescription"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }

        },
        { //13
            name: 'shippingSupplier',
            label: t("supplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {// 14
            name: 'plantEntranceDate', //10
            label: t("plantTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: (cellValue: string, rowIndex: number) => ({
                    align: "center",
                    style: ColorirTempoPlanta(rowIndex)
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (value != null) {
                        return (
                            <CountUp
                                date={value}
                            />)
                    }
                    else {
                        return <></>;
                    }
                }
            }
        },
        {// 15
            name: 'windowStatus',
            label: t("windowStatus"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: (cellValue: string, rowIndex: number) => ({
                    align: "center",
                    style: {
                        backgroundColor: filterData[rowIndex].flagWindowStatus !== 'WHITE' ? filterData[rowIndex].flagWindowStatus : null,
                        color: filterData![rowIndex].flagWindowStatus != "YELLOW" && filterData![rowIndex].flagWindowStatus != "WHITE" ? "white" : "black"
                    }
                })
            }
        },
        { //16
            name: 'presentationDateConcierge',
            label: t("conciergePresentation"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: DataFormat
            }
        },
        {// 17
            name: 'isThereCriticalMaterial',
            label: t("isThereCriticalMaterial"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <Box display='flex' alignItems='center' justifyContent='center'>
                            {value == 'S' ?
                                (
                                    <>
                                        <img src={alert} title="Alerta" height={24} width={24} style={{ marginRight: 5, }} /> Sim
                                    </>
                                ) :
                                'Não'}
                        </Box>
                    );
                }
            }
        }
    ]

    const options = {
        textLabels: {
            body: {
                noMatch: _t('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: _t("next"),
                previous: _t("previous"),
                rowsPerPage: _t("rowsPerPage") + ":",
                displayRows: _t("of"),
            }
        }
    }

    function ColorirTempoPlanta(rowIndex: any) {

        var a = data![rowIndex]?.plantEntranceDate;
        if (!a)
            return {
                backgroundColor: 'white',
                color: color != 'white'
            }

        var color;

        const dataAtual = new Date(Date.now());
        const dataEntrada = new Date(a);

        var diffMs = dataAtual.getTime() - dataEntrada.getTime();
        let days = Math.floor(diffMs / 86400000)
        let hora = Math.floor((diffMs % 86400000) / 3600000) + (days * 24)

        if (hora >= 5) {
            color = "RED";
        } else if (hora < 4) {
            color = "GREEN";
        } else {
            color = "YELLOW";
        }

        return {
            backgroundColor: color,
            color: color != "YELLOW" ? "white" : "black"
        }
    }



    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })

    return (
        <>
            <Backdrop className={classes.backdrop} open={openBackdrop || isLoading || isFetching}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog
                open={dialogOpen}
                onClose={handleDialogClickClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t("attention")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("checkinConfirm")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClickClose}>{_t("cancel")}</Button>
                    <Button onClick={() => handleConfirmation()} autoFocus>{_t("confirm")}</Button>
                </DialogActions>
            </Dialog>

            {!checkinManual && (
                <span onClick={() => setCheckinManual(true)} style={{ padding: 3, display: 'contents', color: '#597DDA', cursor: 'pointer', textDecoration: 'underline', fontWeight: 'bold' }}>
                    {t("manualCheckin")}
                </span>
            )}

            {checkinManual ? (
                <CheckInManual setCheckinManual={setCheckinManual} />
            ) : (
                <>
                    {/* <p>{`${t('totalRecords')} ${filterData.length} : '0'}`}</p> */}

                    <MuiThemeProvider theme={myTheme}>
                        <MUIDataTable
                            title=""
                            data={filterData != null && filterData.length > 0 ? filterData : []}
                            columns={columns}
                            options={{
                                ...options,
                                serverSide: true,
                                pagination: false,
                                sort: false,
                                selectToolbarPlacement: "none",
                                filter: false,
                                search: false,
                                download: false,
                                print: false,
                                viewColumns: false,
                                selectableRows: 'none',
                            }}
                        />
                    </MuiThemeProvider>

                </>
            )}
        </>
    )
}

export default CheckIn;
